import React, {Component } from 'react';
import quizQuestions from './api/quizQuestions';
import Quiz from './components/Quiz';
import Result from './components/Result';
import logo from './svg/logo_light.png';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      answer: '',
      answersCount: {},
      result: ''
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
  }

  componentDidMount() {
    const shuffledAnswerOptions = quizQuestions.map(question =>
      this.shuffleArray(question.answers)
    );
    this.setState({
      question: quizQuestions[0].question,
      answerOptions: shuffledAnswerOptions[0]
    });
  }

  shuffleArray(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value);

    if (this.state.questionId < quizQuestions.length) {
      setTimeout(() => this.setNextQuestion(), 300);
    } else {
      setTimeout(() => this.setResults(this.getResults()), 300);
    }
  }

  setUserAnswer(answer) {
    this.setState((state, props) => ({
      answersCount: {
        ...state.answersCount,
        [answer]: (state.answersCount[answer] || 0) + 1
      },
      answer: answer
    }));
  }

  setNextQuestion() {
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;

    this.setState({
      counter: counter,
      questionId: questionId,
      question: quizQuestions[counter].question,
      answerOptions: quizQuestions[counter].answers,
      answer: ''
    });
  }

  getResults() {
    const answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);
    const answersCountValues = answersCountKeys.map(key => answersCount[key]);
    const maxAnswerCount = Math.max.apply(null, answersCountValues);

    return answersCountKeys.filter(key => answersCount[key] === maxAnswerCount);
  }

  setResults(result) {
    if (result.length === 1) {
      this.setState({ result: result[0] });
    } else {
      this.setState({ result: 'Multipotencialidad' });
    }
  }

  renderQuiz() {
    return (
      <Quiz
        answer={this.state.answer}
        answerOptions={this.state.answerOptions}
        questionId={this.state.questionId}
        question={this.state.question}
        questionTotal={quizQuestions.length}
        onAnswerSelected={this.handleAnswerSelected}
      />
    );
  }

  renderResult() {
    let realName = {
      "Informática" : "Licenciatura en Informática",
      "Administración" : "Licenciatura en Administración",
      "Contaduría" : "Licenciatura en Contaduría",
      "Mercadotecnia" : "Licenciatura en Mercadotecnia",
      "Derecho" : "Licenciatura en Derecho",
      "Educación" : "Licenciatura en Educación",
      "Turismo" : "Licenciatura en Turismo",
      "Proyectos" : "Licenciatura en Proyectos ambientales",
      "Multipotencialidad" : "Lo que tu quieras"
    };

    let panfleto = {
      "Informática" : 7,
      "Administración" : 11,
      "Contaduría" : 16,
      "Mercadotecnia" : 14,
      "Derecho" : 12,
      "Educación" : 10,
      "Turismo" : 13,
      "Proyectos" : 42,
      "Multipotencialidad" : 42
    };

    let realDes = {
      "Informática" : "Son ingeniosos y flexibles, tienen la capacidad de crear y diseñar estrategias que resuelvan y optimicen un problema. Así mismo, tienen la capacidad de organizar y detectar problemas, para así darles una solución efectiva. ",
      "Administración" : "Es una persona caracterizada por sus altas competencias de liderar, gestionar, trazar y conducir. De igual manera, tiene la capacidad de elaborar y ejecutar proyectos que produzcan, distribuyan y generen.",
      "Contaduría" : "Son personas críticas, con objetivos y políticas establecidas. Así mismo, le gusta planificar, coordinar y controlar. Analiza, ejemplifica y ejecuta proyectos sobre presupuestos, sistemas de control financiero, entre otros.",
      "Mercadotecnia" : "Experto en el área de ventas, fácil de desenvolverse en un medio en el que tratar con tantas personas se le hace atractivo y manejable. Está en constante uso de las redes sociales. Tiene objetivos específicos, analiza y organiza campañas publicitarias. ",
      "Derecho" : "Es una persona con rasgos ciertamente marcados, es reflexivo, analista, investigador, expresión oral, habilidades comunicativas, Competitivo, responsable, creativo. Tiene dominio en la disciplina jurídica. ",
      "Educación" : "Le agradan las dinámicas de enseñanza, es facilitador, proveedor, un guía en el acompañamiento del estudiante. Será competente para crear proyectos educativos, generar propuestas de intervención educativa, entre otros. ",
      "Turismo" : "Es altamente competitivo, le gusta organizar y crear, así como dirigir y planificar. De igual manera, le gusta adquirir conocimientos nuevos constantemente en relación a idiomas, comidas, bebidas, cultura, vestimentas, etc.",
      "Proyectos" : "Le interesa el impacto que repercute en el medio ambiente. Es creativo e innovador, realiza proyectos de investigación sustentables, para poder generar cambios en el ámbito natural. ",
      "Multipotencialidad" : "Tienes algunas preferencias, habilidades y conocimientos que son compatibles con distintas licenciaturas. Por lo que se te sugiere estudiar más de una licenciatura, para que puedas aprovechar tu potencial, el cual es altamente competente."
    };

    if(localStorage.getItem("user") !== null){
      let local = JSON.parse(localStorage.getItem("user"));
      return <Result quizResult={local.interes} quizDesc={local.desc} mode={2} panfleto={panfleto[this.state.result]}/>;
    } else {
      return <Result quizResult={realName[this.state.result]} quizDesc={realDes[this.state.result]} mode={1} panfleto={panfleto[this.state.result]}/>;
    }
    
  }

  activaQuiz() {
    document.getElementById('content').classList.remove("d-none");
    document.getElementById('card-welcome').classList.add("d-none");
  }


  render() {
    return (
      <div className="App">
        <div className="App-header">
          <a href="/">
            <img src={logo} className="App-logo" alt="logo" />
          </a>
        </div>
        <div class="card" id="card-welcome">
          <div class="card-body container">
            <p>
              Descubre con que carrera de <b>UNISANT</b> tienes mayor afinidad con {quizQuestions.length} sencillas preguntas.
            </p>
            <div class="text-center mt-5">
              <button onClick={this.activaQuiz} id="" class="btn iniciar" >Iniciar</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="d-none card-body container" id="content">
            {this.state.result || localStorage.getItem("user") !== null ? this.renderResult() : this.renderQuiz()}
          </div>
        </div>
      </div>
    );
  }
}

export default App;
